const supplierColors = {
  "60BB3692-528D-4B1A-8AF9-07E46F55B2B4": "#1f77b4", // Direct Energy - blue
  "32A9E1A8-DF19-4B70-8793-0D1695FD90DF": "#c7c7c7", // Ammper Power - orange
  "64304CDD-0011-4A7E-B0E5-147C9FF78675": "#2ca02c", // APG&E - green
  "FF2AAC3F-BDC8-4E19-AB14-16E2D2A55573": "#d62728", // Nextera Energy - red
  "875C7031-92CB-4ABE-811F-1733A049EBF4": "#9467bd", // Constellation - purple
  "3B0CD20F-FB31-4797-B510-185F51A0DFA1": "#8c564b", // Genie Retail Energy - brown
  "8F63A33F-41DB-4129-B0B4-1A59370D0403": "#e377c2", // New Wave Energy - pink
  "6D13B50B-3260-4279-A3B5-1D7E68091ABB": "#7f7f7f", // Atlantic Energy - gray 
  "958A3FC6-21D4-430F-8834-209E801A7C39": "#bcbd22", // Freepoint Energy - yellow-green
  "21043EB4-B9A4-4BBC-9CAD-26C15DFE25EC": "#17becf", // Champion Energy - cyan
  "120DE132-5154-44C1-BC5E-42AEC6ED6909": "#aec7e8", // Hudson Energy - light blue
  "3BAE837B-8BC7-4574-A32F-4AD870C6580D": "#ffbb78", // Indra Energy - peach
  "6CE62215-20C0-434E-8AF6-4AF301016DDB": "#98df8a", // CleanSky Energy - mint green
  "C4645DA4-BA8F-4973-9AAE-532FB0505B07": "#ff9896", // AEP Energy - light red
  "D1255099-73AB-4D12-B466-542D75DD221B": "#c5b0d5", // IronHorse Power - lavender
  "38E36FC8-0C9A-4774-9632-555E6C28BB37": "#c49c94", // NRG - beige
  "702D1F26-0DDC-4A61-AC9F-62C96FE1C136": "#f7b6d2", // First Point Power - rose
  "6BD2C20F-0CE3-4B00-ACDE-63569A4273A1": "#ff7f0e", // ENGIE - light gray
  "EE091DE1-695B-4257-B491-688FEC24D852": "#dbdb8d", // Catalyst Power - sand
  "D2BE4A8A-780F-4DB1-9EDC-760E9F3222DD": "#9edae5", // Gexa Energy - light cyan
  "9FEDD1C8-EB97-404C-9E3C-7A267473CCD4": "#393b79", // Spark Energy - navy
  "C9BC8032-1424-4E15-86B7-8BCD426682BB": "#637939", // Nordic Energy Services - moss green
  "A638D4CA-A76A-4861-B1C1-996796FAE4F6": "#8c6d31", // SFE Energy - olive
  "63A4EA14-1C3C-440A-B764-A070BE7C93A7": "#843c39", // Summer Energy - maroon
  "052A4363-A6F9-4EF4-9303-B0580FCCE290": "#7b4173", // HomeField Energy - plum
  "02E684F6-4291-4B71-A37D-C03382FE38E2": "#17becf", // Santanna Energy - cyan (shared)
  "41C9C9C8-F2E6-4B82-BDBE-C55243D41803": "#e6550d", // Chariot Energy - burnt orange
  "9C5337FD-2030-4510-BD57-C736BFDD8E35": "#31a354", // TXU Energy - forest green
  "3277A3E0-95BC-425C-B729-CC7AE6DF81AD": "#756bb1", // Gas South - muted purple
  "A837B820-C9CF-4295-8275-E351445959A4": "#636363", // Dynegy - medium gray
  "374BD0E8-60AC-4A6A-BE86-EF7191E47047": "#e7ba52", // Sprague Energy - mustard
  "B504A381-E243-4559-AD3B-FAF13ECF1BA7": "#a55194", // Branch Energy - orchid
  "F232C168-5F59-4C6B-B80B-7E0EE34A259E": "#a55194", // Branch Energy - orchid
  "D0875BF1-3955-4EBB-9518-FD0890AC29C3": "#6b6ecf" , // DEMO Supplier - periwinkle
  "F77C0E8B-B23D-4BF5-AB05-1947E7E44E25": "#9cdcde" // Gridwealth - light purple
};

// Create reverse mapping from supplier names to identifiers
const supplierNameToId = {
  "Direct Energy": "60BB3692-528D-4B1A-8AF9-07E46F55B2B4",
  "Ammper Power": "32A9E1A8-DF19-4B70-8793-0D1695FD90DF",
  "APG&E": "64304CDD-0011-4A7E-B0E5-147C9FF78675",
  "Nextera Energy": "FF2AAC3F-BDC8-4E19-AB14-16E2D2A55573",
  "Constellation": "875C7031-92CB-4ABE-811F-1733A049EBF4",
  "Genie Retail Energy": "3B0CD20F-FB31-4797-B510-185F51A0DFA1",
  "New Wave Energy": "8F63A33F-41DB-4129-B0B4-1A59370D0403",
  "Atlantic Energy": "6D13B50B-3260-4279-A3B5-1D7E68091ABB",
  "Freepoint Energy": "958A3FC6-21D4-430F-8834-209E801A7C39",
  "Champion Energy": "21043EB4-B9A4-4BBC-9CAD-26C15DFE25EC",
  "Hudson Energy": "120DE132-5154-44C1-BC5E-42AEC6ED6909",
  "Indra Energy": "3BAE837B-8BC7-4574-A32F-4AD870C6580D",
  "CleanSky Energy": "6CE62215-20C0-434E-8AF6-4AF301016DDB",
  "AEP Energy": "C4645DA4-BA8F-4973-9AAE-532FB0505B07",
  "IronHorse Power": "D1255099-73AB-4D12-B466-542D75DD221B",
  "NRG": "38E36FC8-0C9A-4774-9632-555E6C28BB37",
  "First Point Power": "702D1F26-0DDC-4A61-AC9F-62C96FE1C136",
  "ENGIE": "6BD2C20F-0CE3-4B00-ACDE-63569A4273A1",
  "Catalyst Power": "EE091DE1-695B-4257-B491-688FEC24D852",
  "Gexa Energy": "D2BE4A8A-780F-4DB1-9EDC-760E9F3222DD",
  "Spark Energy": "9FEDD1C8-EB97-404C-9E3C-7A267473CCD4",
  "Nordic Energy Services": "C9BC8032-1424-4E15-86B7-8BCD426682BB",
  "SFE Energy": "A638D4CA-A76A-4861-B1C1-996796FAE4F6",
  "Summer Energy": "63A4EA14-1C3C-440A-B764-A070BE7C93A7",
  "HomeField Energy": "052A4363-A6F9-4EF4-9303-B0580FCCE290",
  "Santanna Energy": "02E684F6-4291-4B71-A37D-C03382FE38E2",
  "Chariot Energy": "41C9C9C8-F2E6-4B82-BDBE-C55243D41803",
  "TXU Energy": "9C5337FD-2030-4510-BD57-C736BFDD8E35",
  "Gas South": "3277A3E0-95BC-425C-B729-CC7AE6DF81AD",
  "Dynegy": "A837B820-C9CF-4295-8275-E351445959A4",
  "Sprague Energy": "374BD0E8-60AC-4A6A-BE86-EF7191E47047",
  "Branch Energy": "B504A381-E243-4559-AD3B-FAF13ECF1BA7",
  "DEMO Supplier": "D0875BF1-3955-4EBB-9518-FD0890AC29C3",
  "Gridwealth":"F77C0E8B-B23D-4BF5-AB05-1947E7E44E25"
};

export {supplierColors, supplierNameToId};
